import { createContextHook } from '@/utils';
import { CategorySelectContext } from '../CategorySelectContext';

export const useCategorySelectContext = createContextHook(
  CategorySelectContext
);
